import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/button';
import { navigationLinks } from '../../data/mock';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (href) => location.pathname === href;

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-36 md:h-44">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="https://customer-assets.emergentagent.com/job_f4ef9e04-9139-4323-b854-e5d21a16af08/artifacts/pah2ztj3_Untitled%20design%20%282%29%20%281%29.png" 
              alt="Jolly Tots Rides" 
              className="h-32 md:h-40 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-5">
            {navigationLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className={`text-base font-medium transition-colors duration-200 ${
                  isActive(link.href)
                    ? 'jolly-text-orange'
                    : 'text-gray-500 hover:jolly-text-orange'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Link to="/parents">
              <Button className="jolly-btn-orange text-sm">
                For Parents
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-600" />
            ) : (
              <Menu className="w-6 h-6 text-gray-600" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t shadow-lg mobile-menu-enter">
          <div className="px-4 py-4 space-y-3">
            {navigationLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className={`block py-2 px-4 rounded-lg text-base font-semibold transition-colors ${
                  isActive(link.href)
                    ? 'bg-orange-50 jolly-text-orange'
                    : 'text-gray-600 hover:bg-gray-50'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/parents"
              className="block"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <Button className="jolly-btn-orange w-full mt-2">
                For Parents
              </Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
